let $ = require('../../../../../../../webpack/node_modules/jquery');
let nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');
let pins = require('./pins')

$(document).ready(function () {
	if(!$('.tx-psr-sortenfinder').length || !window.sortenfinderMemoPluginOnPage) {
		return;
	}
    nunjucks.configure('/template/dist/views-sortenfinder', {autoescape: true});
    docBody = $('body')
    contentContainer = $('.sortenfinder-list__contents-memo');
	const getData = require('./getData')
	const lang = document.documentElement.lang || 'default'

    let content = []

    if (typeof detailUri !== 'undefined') {
        uri = detailUri;
    }
    if (typeof sustainerUri !== 'undefined') {
        sustainer = sustainerUri;
    }

	getData.loadData(window.jsonUri, lang)
		.then(init)

	$(document).on("click", '.memo-remove',function(event) {
		idToRemove = $(this).closest('.entry').data("id");
		pins.remove(idToRemove)
		updateView()
	});

    function init(data) {
        content = data.content
	    updateView()
    }

    function updateView() {
	    let storedPins = pins.getPins()
	    let pinnedItems = content.filter(item => storedPins.includes(item.psrId))
	    createViewMemo(contentContainer, pinnedItems)
    }
});


/**
 *
 * @param contentContainer
 * @param contentElements
 */
function createViewMemo(contentContainer, contentElements) {
    contentsObj = nunjucks.render('memo-list.html.twig', {lang: lang, label: label, memoHeader: memoHeader, memoHeaderText: memoHeaderText, backLink: backLink, contents: contentElements, pagelink: uri, sustainer: sustainer, login: login, becomePatronUri: becomePatronUri, memoUri: memoUri, loginUri: loginUri, orderUri: orderUri});
    contentContainer.html(contentsObj);

}


